"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rightArrowSymbol = exports.interpunctSymbol = exports.datepickerName = exports.START_EVENING_HOUR = exports.OFFSET_TIMEZONE_MSK = void 0;
// имя генерируется react-datepicker, при смене проверить стили в Calendar.tsx
var datepickerName = 'react-datepicker';
exports.datepickerName = datepickerName;
var OFFSET_TIMEZONE_MSK = 3;
exports.OFFSET_TIMEZONE_MSK = OFFSET_TIMEZONE_MSK;
var START_EVENING_HOUR = 18;
exports.START_EVENING_HOUR = START_EVENING_HOUR;
var rightArrowSymbol = "\u2192";
exports.rightArrowSymbol = rightArrowSymbol;
var interpunctSymbol = "\xB7";
exports.interpunctSymbol = interpunctSymbol;